// https://vuex.vuejs.org/en/getters.html
import { Ability } from "@casl/ability";
export default {
  currentUser(state) {
    return state.user;
  },
  isAuthenticated(state) {
    return state.isAuthenticated;
  },
  isAdmin(state) {
    return state.isAdmin;
  },
  billings(state) {
    return state.billings;
  },
  billingIsLoading(state) {
    return state.isLoading;
  },
  billingsCount(state) {
    return state.billingsCount;
  },
  errors(state) {
    return state.errors;
  },
  accessLevel(state) {
    return state.accessLevel;
  },
  message(state) {
    return state.message;
  },
  loading(state) {
    return state.loading;
  },
  ability() {
    return new Ability([], {
      subjectName(subject) {
        return !subject || typeof subject === "string"
          ? subject
          : subject.$type;
      }
    });
  }
};
